import React from 'react';
import styled from 'styled-components';

import * as COLORS from '~/colors';
import { media } from '~/utils';

export default function ({ recruitment, sdg }) {
  return (
    <Wrapper>
      <Title>{recruitment.category}</Title>
      <Main>
        <Left>
          <Image src={recruitment.image} alt='image-recruitment' />
        </Left>
        <Right>
          <Name>募集対象</Name>
          <RecruitmentTitle>{recruitment.title}</RecruitmentTitle>
          <Description>{recruitment.description}</Description>
        </Right>
      </Main>
      <Button color={COLORS.sdgs[sdg]}>
        <ButtonIcon src='/images/message.svg' />
        <ButtonText>お問い合わせ</ButtonText>
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div`
  padding: 20px 35px 40px;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${media.mid`
    padding-top: 30px;
    padding-bottom: 60px;
    flex-direction: column;
  `}
`;

const Left = styled.div``;

const Right = styled.div`
  margin-left: 30px;

  ${media.mid`
    margin-top: 20px;
    margin-left: 0;
  `}
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
`;

const Name = styled.div`
  font-size: 12px;
  color: #070707;
`;

const RecruitmentTitle = styled.div`
  font-size: 24px;
  line-height: 40px;
  font-weight: bold;
  color: #070707;
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 25px;
  color: #070707;
`;

const Button = styled.div`
  width: 160px;
  height: 43px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: linear-gradient(
    to left,
    ${(props) => props.color.end},
    ${(props) => props.color.start}
  );
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 10px 0 10px 0;
`;

const ButtonIcon = styled.img``;

const ButtonText = styled.div`
  margin-left: 20px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
`;
